<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/suscripcion" v-if="getIdPerfil == 1"
              >Suscripciones</router-link
            >
            <router-link
              :to="'/empresaform/' + datoSuscripcion.idEmpresa"
              v-else
            >
              Información Empresa
            </router-link>
            > {{ datoSuscripcion.usuarioNombre }}
          </div>
        </div>
        <div class="col-1">
          <span
            class="material-symbols-outlined"
            style="font-size: 32px; color: blue; cursor: pointer"
            @click="showModalHelp = true"
            >help
          </span>
        </div>
      </div>
    </div>
    <hr />
    <!-- Modal -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <form>
          <div class="modal-body">
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idSuscripcion" class="form-label">Id</label>
                </div>
                <div class="col-10">
                  <span id="idSuscripcion" class="form-control-plaintext">{{
                    datoSuscripcion.idSuscripcion
                  }}</span>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="planNombre" class="form-label"> Plan</label>
                </div>
                <div class="col-2">
                  <span id="planNombre" class="form-control-plaintext">{{
                    datoSuscripcion.planNombre
                  }}</span>
                </div>
                <div class="col-2">
                  <label for="formaPagoNombre" class="form-label">
                    Forma Pago</label
                  >
                </div>
                <div class="col-2">
                  <span id="formaPagoNombre" class="form-control-plaintext">{{
                    datoSuscripcion.formaPagoNombre
                  }}</span>
                </div>
                <div class="col-2">
                  <label for="numero" class="form-label">Número</label>
                </div>
                <div class="col-2">
                  <span id="numero" class="form-control-plaintext">{{
                    datoSuscripcion.numero
                  }}</span>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaDesde" class="form-label">FechaDesde</label>
                </div>
                <div class="col-2">
                  <span id="fechaDesde" class="form-control-plaintext">{{
                    getFormattedDateTime(datoSuscripcion.fechaDesde)
                  }}</span>
                </div>
                <div class="col-2">
                  <label for="fechaHasta" class="form-label">FechaHasta</label>
                </div>
                <div class="col-2">
                  <span id="fechaHasta" class="form-control-plaintext">{{
                    getFormattedDateTime(datoSuscripcion.fechaHasta)
                  }}</span>
                </div>
                <div class="col-2">
                  <label for="fechaReg" class="form-label">Fecha Reg</label>
                </div>
                <div class="col-2">
                  <span id="fechaReg" class="form-control-plaintext">{{
                    getFormattedDateTime(datoSuscripcion.fechaReg)
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Estructura de Tabs -->
    <div class="tabs">
      <button
        class="tablink"
        @click="showTable = 'suscPago'"
        :class="{ 'active-tab': showTable === 'suscPago' }"
      >
        Pagos
      </button>
      <button
        class="tablink"
        @click="showTable = 'suscripcionAud'"
        :class="{ 'active-tab': showTable === 'suscripcionAud' }"
      >
        Auditoría
      </button>
      <button
        class="tablink"
        @click="showTable = 'usuarioSusc'"
        :class="{ 'active-tab': showTable === 'usuarioSusc' }"
      >
        Usuarios
      </button>
    </div>

    <!-- Contenido dinámico según la pestaña seleccionada -->
    <div v-if="showTable === 'suscPago'">
      <SuscPago :p_idSuscripcion="p_idSuscripcion"></SuscPago>
    </div>
    <div v-if="showTable === 'suscripcionAud'">
      <SuscripcionAud :p_idSuscripcion="p_idSuscripcion"></SuscripcionAud>
    </div>
    <div v-if="showTable === 'usuarioSusc'">
      <UsuarioSusc :p_idSuscripcion="p_idSuscripcion"></UsuarioSusc>
    </div>

    <Footer />
  </div>
</template>
<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import dateFormat from "@/modules/dateFormat.js";
import SuscPago from "../forms/SuscPago.vue";
import SuscripcionAud from "../forms/SuscripcionAud.vue";
import UsuarioSusc from "../forms/UsuarioSusc.vue";


import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
//import swal from  'sweetalert'
export default {
  components: {
    Layout,
    Footer,
    SuscPago,
    SuscripcionAud,
    UsuarioSusc,
  },
  data() {
    return {
      suscripcions: [],
      datoSuscripcion: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      modalWindow: true,
      p_idSuscripcion: 0,
      plans: [],
      formaPagos: [],
      showTable: "suscPago", // Pestaña por defecto
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
    };
  },
  computed: {
    getIdPerfil() {
      if (typeof window !== "undefined" && window.sessionStorage) {
        return sessionStorage.getItem("idPerfil");
      }
      return null;
    },
  },

  mounted() {
    this.p_idSuscripcion = this.$route.params.p_idsuscripcion;
    this.getData();
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    // this.fetchPlans()
    // this.fetchFormaPagos()
  },
  methods: {
    getFormattedDateTime(date) {
      return dateFormat.getFormattedDateTime(date);
    },
    getData() {
      api.get("/vwsuscripcions/idsuscripcion/" +
            this.p_idSuscripcion
        )
        .then((response) => {
          this.datoSuscripcion = response.data;
        })
        .catch((error) => {
          console.error("Error al obtener datos de la persona:", error);
        });
    },
    /*     async guardarSuscripcion(){
      if(this.validarForm() === 1){
        try {
          this.datoSuscripcion.idUsuario = window.sessionStorage.getItem("idUsuario");
          await api.post('/suscripcions', this.datoSuscripcion)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Suscripcion creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    }, */
    /*     fetchPlans() {
      fetch(config.apiBaseUrl + '/plans')
        .then(response => response.json())
        .then(data => {
          this.plans = data;
        })
        .catch(error => {
          console.error('Error fetching plans:', error);
        });
    },
    fetchFormaPagos() {
      fetch(config.apiBaseUrl + '/formapagos')
        .then(response => response.json())
        .then(data => {
          this.formaPagos = data;
        })
        .catch(error => {
          console.error('Error fetching formaPagos:', error);
        });
    }, */
  },
};
</script>
<style src="@/assets/css/tabs.css" scoped></style>
